import {AXIS_REQUEST, AXIS_SHOW, AXIS_EDIT, AXIS_CLEAR, AXIS_FAIL} from "../store/config";

const axisInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:''
	},
	edit: {},
	permissions: [],
	error: undefined
}

const axis = (state = axisInit, action) => {
	switch (action.type) {
		case AXIS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case AXIS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AXIS_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AXIS_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case AXIS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default axis;


// WEBPACK FOOTER //
// ./src/reducers/axis.js